:host {
  --br-scrim-opacity: 1;

  .br-scrim {
    visibility: hidden;
    transition: visibility 0.3s ease;
    z-index: var(--z-index-layer-4);
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: auto;
  }

  .br-scrim.mode-fullscreen {
    position: fixed;
    inset: 0;
  }

  .br-scrim.mode-parent {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }

  .br-scrim.opened {
    visibility: visible;
    pointer-events: auto;
  }

  .br-scrim.variant-legibility {
    pointer-events: none;
    z-index: auto;

    .mask {
      pointer-events: none;
      z-index: auto;
    }

    .content {
      pointer-events: auto;
      z-index: auto;
    }
  }

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--surface-overlay-scrim);
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: auto;
  }

  .br-scrim.opened .mask {
    opacity: var(--br-scrim-opacity);
  }

  .br-scrim.has-spotlight .mask {
    display: none;
  }

  .spotlight-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: auto;
    overflow: visible;
  }

  .br-scrim.mode-fullscreen .spotlight-overlay {
    position: fixed;
  }

  .spotlight-overlay-rect {
    fill: var(--surface-overlay-scrim, #000);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .br-scrim.opened .spotlight-overlay-rect {
    opacity: var(--br-scrim-opacity);
  }

  .br-scrim.legibility-anchor-center .mask {
    width: 100%;
    height: var(--br-scrim-mask-size, 100%);
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  .br-scrim.legibility-anchor-center .content {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    width: 100%;
    height: var(--br-scrim-mask-size, 100%);
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .br-scrim.legibility-anchor-top .mask,
  .br-scrim.legibility-anchor-bottom .mask {
    height: var(--br-scrim-mask-size, 100%);
    width: 100%;
  }

  .br-scrim.legibility-anchor-left .mask,
  .br-scrim.legibility-anchor-right .mask {
    width: var(--br-scrim-mask-size, 100%);
    height: 100%;
  }

  .br-scrim.legibility-anchor-top .mask {
    top: 0;
    bottom: auto;
  }

  .br-scrim.legibility-anchor-bottom .mask {
    bottom: 0;
    top: auto;
  }

  .br-scrim.legibility-anchor-left .mask {
    left: 0;
    right: auto;
  }

  .br-scrim.legibility-anchor-right .mask {
    right: 0;
    left: auto;
  }

  .br-scrim.legibility-anchor-top .content {
    position: absolute;
    inset: 0 0 auto;
    width: 100%;
    height: var(--br-scrim-mask-size, 100%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .br-scrim.legibility-anchor-bottom .content {
    position: absolute;
    inset: auto 0 0;
    width: 100%;
    height: var(--br-scrim-mask-size, 100%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .br-scrim.legibility-anchor-left .content {
    position: absolute;
    inset: 0 auto 0 0;
    width: var(--br-scrim-mask-size, 100%);
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .br-scrim.legibility-anchor-right .content {
    position: absolute;
    inset: 0 0 0 auto;
    width: var(--br-scrim-mask-size, 100%);
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .content {
    position: relative;
    outline: none;
    pointer-events: auto;
    opacity: 0;
    transform: scale(0.9);
    transition:
      opacity 0.3s ease,
      transform 0.3s ease;
    background: transparent;
    padding: 0;
    margin: 0;
    border: none;
    box-shadow: none;
    overflow: visible;
    contain: none;
    display: inline-block;
    width: fit-content;
    height: fit-content;
    z-index: calc(var(--z-index-layer-4) + 1);

    &:focus {
      outline: var(--focus-outline);
      outline-offset: var(--focus-offset);
      box-shadow: var(--focus-shadow);
    }
  }

  .br-scrim.opened .content {
    opacity: 1;
    transform: scale(1);
    pointer-events: auto;
  }

  .content ::slotted(*) {
    opacity: 1 !important;
    filter: none;
  }

  $no-anchor: ":not(.legibility-anchor-top):not(.legibility-anchor-bottom):not(.legibility-anchor-left):not(.legibility-anchor-right):not(.legibility-anchor-center)";

  .br-scrim.position-top#{$no-anchor} .content {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .br-scrim.position-bottom#{$no-anchor} .content {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .br-scrim.position-left#{$no-anchor} .content {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  .br-scrim.position-right#{$no-anchor} .content {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }

  .br-scrim.position-center#{$no-anchor} .content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .br-scrim[class*="legibility-anchor-"].position-top .content {
    align-items: flex-start;
    justify-content: center;
  }

  .br-scrim[class*="legibility-anchor-"].position-bottom .content {
    align-items: flex-end;
    justify-content: center;
  }

  .br-scrim[class*="legibility-anchor-"].position-left .content {
    align-items: center;
    justify-content: flex-start;
  }

  .br-scrim[class*="legibility-anchor-"].position-right .content {
    align-items: center;
    justify-content: flex-end;
  }

  .br-scrim[class*="legibility-anchor-"].position-center .content {
    align-items: center;
    justify-content: center;
  }

  .br-scrim.legibility-anchor-center.position-top .content {
    align-items: flex-start;
    justify-content: center;
    transform: translateY(-50%);
  }

  .br-scrim.legibility-anchor-center.position-bottom .content {
    align-items: flex-end;
    justify-content: center;
    transform: translateY(-50%);
  }

  .br-scrim.legibility-anchor-center.position-left .content {
    align-items: center;
    justify-content: flex-start;
    transform: translateY(-50%);
  }

  .br-scrim.legibility-anchor-center.position-right .content {
    align-items: center;
    justify-content: flex-end;
    transform: translateY(-50%);
  }

  .br-scrim.legibility-anchor-center.position-center .content {
    align-items: center;
    justify-content: center;
    transform: translateY(-50%);
  }

  @media (width <= 768px) {
    .content {
      max-width: 95%;
      max-height: 95%;
      width: auto;
    }

    .br-scrim.position-top .content,
    .br-scrim.position-bottom .content {
      width: 100%;
      max-width: 100%;
      border-radius: 0;
    }
  }
}
